import { FormattedMessage, useIntl } from 'react-intl'
import { string } from 'yup'
import { H3, TinyText } from '../common/typography'
import { CheckOrRadio } from '../common/forms'
import { Checkbox } from '../assets/icons'
import { FeatureToggle } from '../common/feature-toggle'
import { featureCodes } from 'shared/utils'
import { updateOptinPushBackend } from 'shared/store/user'
import { useDispatch, useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { Formik, Form } from 'formik'
import { Layout } from '../common/layout'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { BORDER, SPACING } from '../../app-v2/design-tokens'
import { media, ResponsiveContainer } from '../assets/styles'

export function OptinsScreen() {
    const intl = useIntl()

    const { optinPush } = useSelector((state: RootState) => state.userState)
    const dispatch = useDispatch()

    return (
        <Layout backgroundColor={colors.lightMayo}>
            <MainContainer>
                <Formik
                    initialValues={{ push: optinPush ?? true }}
                    onSubmit={values => {
                        dispatch(updateOptinPushBackend(values.push))
                    }}>
                    {({ values, setFieldValue }) => (
                        <Form>
                            <StyledContainer>
                                <FormattedMessage id="kingdom.profile.form.optins.title">
                                    {(text: string) => <H3>{text}</H3>}
                                </FormattedMessage>
                                <FeatureToggle
                                    feature={featureCodes.OPTIN_PUSH}>
                                    <StyledOptinsContainer
                                        onClick={() => {
                                            const newValue = !values.push
                                            setFieldValue('push', newValue)
                                            dispatch(
                                                updateOptinPushBackend(newValue)
                                            )
                                        }}>
                                        <CheckOrRadio
                                            name="push"
                                            type="checkbox"
                                            labelKey="kingdom.profile.form.optins.push"
                                            checked={values.push}
                                            className="agreements">
                                            <Checkbox checked={values.push} />
                                        </CheckOrRadio>
                                        <TinyText>
                                            {intl.formatMessage({
                                                id:
                                                    'kingdom.profile.form.optins.push.auth.mention'
                                            })}
                                            <TinyText color={colors.bbqBrown}>
                                                {intl.formatMessage({
                                                    id:
                                                        'kingdom.profile.form.optins.push.auth.mention.link'
                                                })}
                                            </TinyText>
                                        </TinyText>
                                    </StyledOptinsContainer>
                                </FeatureToggle>
                            </StyledContainer>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </Layout>
    )
}

const MainContainer = styled(ResponsiveContainer)`
    margin-top: 80px;
    margin-bottom: 220px;
    align-items: center;
    ${media.medium`
        margin-top: 120px;
        margin-bottom: 225px;
    `};
`

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${SPACING.L};
`

const StyledOptinsContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${colors.white};
    border-radius: ${BORDER.RADIUS.L};
    padding: ${SPACING.M};
    gap: ${SPACING.M};
`
